import { Toast } from "../../lib/helpers/helpers";
import Auth from "../../lib/middleware/auth";

const errorHandler = (err) => {
	console.log("========ERROR=======");
	console.log(err);
	console.log("====================\n\n");
	// console.log("=========ERROR BODY=========");
	// console.log(err.response);
	// console.log("===========================\n\n");
	if (err.response) {
		// eslint-disable-next-line
		if (err.response.status == 401) {
			Toast.fire({
				icon: "error",
				title: `Unauthorized \nPlease login to continue`,
			});
		}
		// eslint-disable-next-line
		if (err.response.status == 417) {
			Toast.fire({
				icon: "error",
				title: `${err.response.data.message}`,
			});
		}
		// eslint-disable-next-line
		if (err.response.status == 402 || err.response.status == 405) {
			Toast.fire({
				icon: "error",
				title: `${err.response.data.message}`,
			});
		}
		// eslint-disable-next-line
		if (err.response.status == 400) {
			Toast.fire({
				icon: "error",
				title: `${err.response.data.message}`,
			});
		} else {
			Toast.fire({
				icon: "error",
				title: `internal server error`,
			});
		}
	} else if (err.code) {
		// eslint-disable-next-line
		if (err.code == 450) {
			Toast.fire({
				icon: "error",
				title: `Unauthorized \nPlease login to continue`,
			});
			setTimeout(() => {
				Auth.destroyToken();
				window.location.reload();
			}, 1000);
		} else {
			Toast.fire({
				icon: "error",
				title: `${err.title}\n${err.message}`,
			});
		}
	} else {
		Toast.fire({
			icon: "error",
			title: `Network Error!`,
		});
	}
};

export default errorHandler;
